import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'mainCharts',
    label: 'Main Charts',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
